<template lang="pug">
v-dialog(v-model="dialog" width="640" persistent)
  v-card(v-if="!submited")
    v-card-title {{ simple ? 'Importar productos o servicios' : 'Importar productos, líneas y capacidad' }}
    v-card-text
      v-form(ref="form" @submit.prevent="onSubmit")
        div.mb-2(v-if="simple") Carga tus líneas de negocio con sus productos o servicios (ticket y costo). Descarga la
          a(href="/plantilla-productos-simple.xlsx" target="_blank" download)  plantilla aquí
          | .
        div.mb-2(v-else) Carga en un solo archivo tus líneas de negocio, productos base, SKU (precio y costo) y capacidad. Las líneas y los productos base se crean solos. Descarga la
          a(href="/plantilla-productos-completa.xlsx" target="_blank" download)  plantilla aquí
          | .
        v-file-input(
          label="Archivo (.xlsx o .csv)"
          v-model="form.file"
          persistent-hint
          outlined
          accept=".csv,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="onFileChange"
          :rules="v.file")
        .text-right
          v-btn.mr-2(color="primary" outlined @click="closeDialog" :disabled="loading") Cancelar
          v-btn(color="primary" type="submit" :loading="loading") Guardar
  v-card(v-else-if="errors && errors.length > 0")
    v-card-title Falló la Carga
    v-card-text
      .d-flex.justify-center.align-center
        v-icon.mx-auto(color="error" size="80") mdi-alert-circle-outline
      v-card-text.text-center
        div Elementos cargados: {{ itemsUploaded }} / {{ itemsCount }}
        div Encontramos errores al cargar. Revisa el detalle y vuelve a intentar.
      ul
        li(v-for="error in errors" :key="error") {{ error }}
      .text-right.mt-4
        v-btn.mr-2(color="primary" outlined @click="closeDialog" :disabled="loading") Cerrar
  v-card(v-else)
    v-card-title Archivo Subido Correctamente
    v-card-text
      .d-flex.justify-center.align-center
        v-icon.mx-auto(color="success" size="80") mdi-check-circle-outline
    v-card-text
      .text-center
        div Se importaron {{ itemsCount }} productos con sus líneas y capacidades.
      .text-right.mt-4
        v-btn.mr-2(color="primary" outlined @click="closeDialog" :disabled="loading") Cerrar
</template>

<script>
import { mapActions } from 'vuex'
import FormMixin from '@/components/mixins/FormMixin'
import validations from '@/shared/formValidations'

export default {
  mixins: [FormMixin],
  props: {
    simple: { type: Boolean, default: false },
  },
  data() {
    return {
      submited: false,
      itemsCount: 0,
      itemsUploaded: 0,
      form: {
        file: null,
      },
      dialog: false,
      errors: []
    }
  },
  methods: {
    ...mapActions('product', ['importProductsFull', 'importSimpleProducts']),
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    onError(response) {
      this.loading = false
      const data = (response && (response.data || (response.error && response.error.response && response.error.response.data))) || {}
      this.itemsUploaded = data.created_items || 0
      this.itemsCount = data.total_items || 0
      this.errors = (data.errors && data.errors.length)
        ? data.errors
        : ['No pudimos procesar el archivo. Revisa que sea la plantilla correcta (.xlsx o .csv) con las columnas Línea de Negocio, Producto Base, SKU (Texto), Nombre, Precio de Mercado y Costo Unitario.']
      this.submited = true
      this.$emit('save')
    },
    onSuccess(response) {
      this.loading = false
      const data = (response && response.data) || {}
      this.itemsUploaded = data.created_items || 0
      this.itemsCount = data.total_items || 0
      this.errors = data.errors || []
      this.submited = true
      this.$emit('save')
    },
    onFileChange() {
      this.$refs.form && this.$refs.form.resetValidation()
    },
    getAction() {
      return this.simple ? this.importSimpleProducts : this.importProductsFull
    },
    getData() {
      const formData = new FormData()
      const data = { data: formData }
      for (const key in this.form) {
        formData.append(key, this.form[key])
      }
      return data
    },
    resetForm() {
      this.form = { file: null }
      this.$refs.form && this.$refs.form.resetValidation()
    },
    onClose() {
      this.errors = []
      this.submited = false
      this.loading = false
      this.resetForm()
    }
  },
  computed: {
    v() {
      return {
        file: [
          validations.isRequired,
          (f) => !f || /\.(xlsx|csv)$/i.test(f.name || '') || 'El archivo debe ser .xlsx o .csv'
        ]
      }
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.onClose()
      }
    }
  },
}
</script>
